import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function GmailCallback() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();

  useEffect(() => {
    const status = sp.get("status");
    (async () => {
      await refresh();
      if (status === "ok") toast.success("Gmail connected ✓");
      else toast.error("Failed to connect Gmail: " + (sp.get("msg") || "unknown"));
      navigate("/profile");
    })();
  }, [sp, navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-slate-500">Completing Gmail connection…</div>
    </div>
  );
}
